import React from 'react'
import { styles } from '../../../../../../styles/tailwind-config'

const Checklist = () => {
  return (
    <div>
        <h3 className={`${styles.h3} mb-4`}>Controle van de interventie</h3>
    </div>
  )
}

export default Checklist